import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const propTypes = {
  meterHeight: PropTypes.number.isRequired,
}

const AudioLevelContainer = styled.div`
  text-align: center;
  position: absolute;
  bottom: 0;
  right: 0;
  height: 100%;
  z-index: 2;
  float: right;
  width: ${({ theme }) => theme.space.s20};
  overflow: hidden;
`

const StyledMeter = styled.div`
  height: ${props => props.$meterHeight && `${props.$meterHeight}%`};
  position: absolute;
  background-color: ${({ theme }) => theme.color.success110};
  bottom: 0;
  width: 100%;
  transition: transform 0.15s;
  transform: translateY(meterHeight);
`

export function AudioMeter({ meterHeight }) {
  return (
    <AudioLevelContainer>
      <StyledMeter $meterHeight={meterHeight} />
    </AudioLevelContainer>
  )
}

AudioMeter.propTypes = propTypes

export default AudioMeter
